import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import stockInit from 'highcharts/modules/stock';
import exportingInit from 'highcharts/modules/exporting';
import Croppa from 'vue-croppa';
import VueTimeago from 'vue-timeago';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import 'vue-croppa/dist/vue-croppa.css';

Vue.config.productionTip = false;

stockInit(Highcharts);
exportingInit(Highcharts);

Vue.use(VueAxios, axios);
Vue.use(HighchartsVue);
// Vue.use(require('vue-moment'));
Vue.use(Croppa);
Vue.use(VueTimeago, {
  name: 'timeago', // component name, `timeago` by default
  locale: 'en-US',
});
Vue.use(CKEditor);

import './scss/main.scss';

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
